import React, { useState } from "react";
import { FiImage, FiTrash2 } from "react-icons/fi";
import MediaLibraryModal from "./MediaLibraryModal";

const OneImageUpload = ({ Update, changeImage, sec_image, sec_value, folder_name, MainImage }) => {
  const [mediaOpen, setMediaOpen] = useState(false);
  const clearImage = () => Update((previous) => ({ ...previous, [sec_image]: "", [sec_value]: "" }));

  return (
    <div className="mt-4">
      <div className="mb-2 block text-[.8rem] text-[#243B5A]">Image</div>
      <div className="rounded-[14px] border border-[#DCE5F1] bg-[#F8FAFC] p-3">
        <div className="flex gap-2">
          <div className="flex h-9 min-w-0 flex-1 items-center gap-2 rounded-full border border-[#D8D8D8] bg-white px-3 text-xs text-[#555]">
            <FiImage className="shrink-0 text-[#8A9AB5]" /><span className="truncate">{MainImage || "Image URL"}</span>
          </div>
          <button type="button" onClick={() => setMediaOpen(true)} className="flex h-9 items-center gap-2 rounded-full border border-[#D8D8D8] bg-white px-4 text-xs text-[#333] hover:border-[#B78A42]"><FiImage size={14} /> Gallery</button>
          {MainImage && <button type="button" onClick={clearImage} className="flex h-9 items-center gap-2 rounded-full border border-[#E34D4D] px-4 text-xs text-[#D93636] hover:bg-[#FFF3F3]"><FiTrash2 size={14} /> Clear</button>}
        </div>
        <div className="mt-3 min-h-[112px] rounded-[12px] border border-[#DCE5F1] bg-white p-3">
          {MainImage ? <img src={MainImage} alt="Selected" className="h-[88px] w-[88px] rounded-[12px] object-cover" /> : <div className="grid h-[88px] place-items-center text-xs text-[#98A6BA]">No image selected</div>}
        </div>
      </div>
      <MediaLibraryModal open={mediaOpen} onClose={() => setMediaOpen(false)} initialFolder={folder_name} onSelect={(image) => { Update((previous) => ({ ...previous, [sec_image]: image?.image_full_path || image?.image_path || "", [sec_value]: image?.image_path || "" })); changeImage?.(false); setMediaOpen(false); }} />
    </div>
  );
};

export default OneImageUpload;
